import React, { useMemo } from 'react';
import styled from 'styled-components';
import GowriRow from './GowriRow';

/*
 * GowriPanchangamSection — Section 6 of Pambu Sheet.
 *
 * Full-width section with two GowriRow instances (Day + Night).
 * Active slot computed from `now` against [start, end] windows.
 * Sub-section labels are inline (not separate SectionBlocks).
 */

const SubLabel = styled.h3`
  margin: ${p => p.theme.spacing[2]}px ${p => p.theme.spacing[3]}px ${p => p.theme.spacing[1]}px;
  font-size: 13px;
  font-weight: ${p => p.theme.typography.weights.semibold};
  color: ${p => p.theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const SubLabelEn = styled.span`
  font-weight: ${p => p.theme.typography.weights.regular};
  text-transform: none;
  margin-left: 6px;
  font-size: 11px;
  color: ${p => p.theme.colors.text.muted};
`;

function findActiveIndex(slots, now) {
  if (!slots || !now) return null;
  const toMin = (t) => {
    if (!t) return -1;
    const parts = t.split(':').map(Number);
    return (parts[0] || 0) * 60 + (parts[1] || 0);
  };
  const nowMin = now.getHours() * 60 + now.getMinutes();
  for (let i = 0; i < slots.length; i++) {
    const s = slots[i];
    const startMin = toMin(s.start);
    const endMin = toMin(s.end);
    if (startMin < 0 || endMin < 0) continue;
    if (endMin >= startMin) {
      if (nowMin >= startMin && nowMin < endMin) return i;
    } else {
      // overnight wrap
      if (nowMin >= startMin || nowMin < endMin) return i;
    }
  }
  return null;
}

const GowriPanchangamSection = ({ gowri, now, lang = 'en' }) => {
  const daySlots = gowri?.day || [];
  const nightSlots = gowri?.night || [];

  const activeDayIndex = useMemo(() => findActiveIndex(daySlots, now), [daySlots, now]);
  const activeNightIndex = useMemo(
    () => activeDayIndex == null ? findActiveIndex(nightSlots, now) : null,
    [nightSlots, now, activeDayIndex]
  );

  if (!gowri) return null;

  return (
    <>
      <SubLabel>
        {lang === 'ta' ? 'பகல்' : 'Day'}
        <SubLabelEn>{lang === 'ta' ? 'Day' : 'பகல்'}</SubLabelEn>
      </SubLabel>
      <GowriRow slots={daySlots} activeSlotIndex={activeDayIndex} lang={lang} />

      <SubLabel>
        {lang === 'ta' ? 'இரவு' : 'Night'}
        <SubLabelEn>{lang === 'ta' ? 'Night' : 'இரவு'}</SubLabelEn>
      </SubLabel>
      <GowriRow slots={nightSlots} activeSlotIndex={activeNightIndex} lang={lang} />
    </>
  );
};

export default GowriPanchangamSection;
